"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GhostIconFilledIconUrl = exports.toWebDownloadPageUrl = exports.toAppStoreUrl = exports.UNLOCK_DEEPLINK_URL = void 0;
exports.UNLOCK_DEEPLINK_URL = "https://link.snapchat.com/unlock";
const toAppStoreUrl = (pageTypeName) => `https://apps.apple.com/app/apple-store/id447188370?pt=614006&ct=${pageTypeName}&mt=8`;
exports.toAppStoreUrl = toAppStoreUrl;
const toWebDownloadPageUrl = (pageTypeName) => `https://www.snapchat.com/download?purpose=snapchat_dot_com&sp=${pageTypeName}`;
exports.toWebDownloadPageUrl = toWebDownloadPageUrl;
exports.GhostIconFilledIconUrl = "https://static.snapchat.com/images/ghost-icon-filled.png";
//# sourceMappingURL=urls.js.map